// extracted by mini-css-extract-plugin
module.exports = {"chipsRow":"BBy2nLp"};